import Api from "./base/api-base";

export default class BudgetHistoryApi {
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.budget_history,
      id: id
    });
  }
}